<template>
  <div class="tabbar">
    <div class="tabbar-content" :style="{ backgroundImage: `url(${footerBarBg})` }">
      <div
        class="tabbar-content-item"
        @click="handleClick(item)"
        v-for="(item, index) in getTabbarList"
        :key="index"
      >
        <template v-if="item.key != 'flash'">
          <template v-if="pathStr == item.linkUrl">
            <CmImg :name="item.checkedImgUrl" />
            <div class="tabbar-content-item-text active">{{ item.name }}</div>
          </template>
          <template v-else>
            <CmImg :name="item.imgUrl" />
            <div class="tabbar-content-item-text">{{ item.name }}</div>
          </template>
        </template>
        <template v-else>
          <div class="tabbar-content-item-flash">
            <CmImg :name="item.imgUrl" />
            <div class="tabbar-content-item-text">{{ item.name }}</div>
          </div>
        </template>
      </div>
    </div>
  </div>
  <van-popup
    v-model:show="show"
    position="bottom"
    round
    :style="{
      maxWidth: '550px',
      maxHeight: '100%',
      margin: '0 auto',
      left: '50%',
      transform: 'translateX(-50%)',
      overflowY: 'scroll',
      background: 'transparent !important'
    }"
  >
    <div class="flash-popup">
      <div class="flash-popup-item" @click="handleClick2('/contract')">
        <CmImg name="icon_type_b_20" style="width: 30px; height: 30px; margin-right: 10px" />
        {{ t('sustainable_contract') }}
      </div>
      <div class="flash-popup-item" @click="handleClick2('/trade')">
        <CmImg name="icon_my_home_spot" style="width: 30px; height: 30px; margin-right: 10px" />
        {{ t('spot_trading') }}
      </div>
      <div class="flash-popup-item" @click="handleClick2('/flash')">
        <CmImg name="icon_my_home_s" style="width: 30px; height: 30px; margin-right: 10px" />
        {{ t('option_contract') }}
      </div>
      <div class="flash-popup-item" @click="handleClick2('/flashExchange')">
        <CmImg name="icon_type_f" style="width: 30px; height: 30px; margin-right: 10px" />
        {{ t('flash_exchange') }}
      </div>
    </div>
  </van-popup>
</template>
<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
if (window.__themeEnv === 'YT') {
  import(`@/assets/css/YT/footerBar.scss`)
} else if (window.__themeEnv === 'CICC') {
  import(`@/assets/css/CICC/footerBar.scss`)
} else if (window.__themeEnv === 'CMBIT') {
  import(`@/assets/css/CMBIT/footerBar.scss`)
} else if (window.__themeEnv === 'TKBIT') {
  import(`@/assets/css/TKBIT/footerBar.scss`)
} else if (window.__themeEnv === 'ARKADEX') {
  import(`@/assets/css/ARKADEX/footerBar.scss`)
} else if (window.__themeEnv === 'EXMINING') {
  import(`@/assets/css/EXMINING/footerBar.scss`)
}
const footerBarBg = new URL(
  `../../assets/image/${window.__themeEnv}/footerBar.png`,
  import.meta.url
).href
const getTabbarList = computed(() => {
  const themeMap = {
    EXMINING: [
      {
        imgUrl: 'home',
        checkedImgUrl: 'home-active',
        linkUrl: '/',
        key: 'home',
        name: t('home'),
        sort: 1
      },
      {
        imgUrl: 'store',
        checkedImgUrl: 'store-active',
        linkUrl: '/store',
        key: 'store',
        name: t('market'),
        sort: 2
      },
      {
        imgUrl: 'flash',
        checkedImgUrl: 'flash',
        linkUrl: '/flash',
        key: 'flash',
        name: t('trading'),
        sort: 3
      },
      {
        imgUrl: 'home_four_no_color',
        checkedImgUrl: 'home_four_color',
        linkUrl: '/flashExchange',
        key: 'flashExchange',
        name: t('flash_exchange'),
        sort: 4
      },
      {
        imgUrl: 'wallet',
        checkedImgUrl: 'wallet-active',
        linkUrl: '/wallet',
        key: 'wallet',
        name: t('my'),
        sort: 5
      }
    ],
    TKBIT: [
      {
        imgUrl: 'home',
        checkedImgUrl: 'home-active',
        linkUrl: '/',
        key: 'home',
        name: t('home'),
        sort: 1
      },
      {
        imgUrl: 'store',
        checkedImgUrl: 'store-active',
        linkUrl: '/store',
        key: 'store',
        name: t('market'),
        sort: 2
      },
      {
        imgUrl: 'flash',
        checkedImgUrl: 'flash',
        linkUrl: '/flash',
        key: 'flash',
        name: '',
        sort: 3
      },
      {
        imgUrl: 'finance',
        checkedImgUrl: 'finance-active',
        linkUrl: '/finance',
        key: 'finance',
        name: '理财',
        sort: 4
      },
      {
        imgUrl: 'wallet',
        checkedImgUrl: 'wallet-active',
        linkUrl: '/wallet',
        key: 'wallet',
        name: '资金',
        sort: 5
      }
    ],
    YT: [
      {
        imgUrl: 'home',
        checkedImgUrl: 'home-active',
        linkUrl: '/',
        key: 'home',
        name: '首页',
        sort: 1
      },
      {
        imgUrl: 'store',
        checkedImgUrl: 'store-active',
        linkUrl: '/store',
        key: 'store',
        name: '行情',
        sort: 2
      },
      {
        imgUrl: 'flash',
        checkedImgUrl: 'flash',
        linkUrl: '/flash',
        key: 'flash',
        name: '交易',
        sort: 3
      },
      {
        imgUrl: 'finance',
        checkedImgUrl: 'finance-active',
        linkUrl: '/finance',
        key: 'finance',
        name: '理财',
        sort: 4
      },
      {
        imgUrl: 'wallet',
        checkedImgUrl: 'wallet-active',
        linkUrl: '/wallet',
        key: 'wallet',
        name: '我的',
        sort: 5
      }
    ],
    CICC: [
      {
        imgUrl: 'home',
        checkedImgUrl: 'home-active',
        linkUrl: '/',
        key: 'home',
        name: '首页',
        sort: 1
      },
      {
        imgUrl: 'store',
        checkedImgUrl: 'store-active',
        linkUrl: '/store',
        key: 'store',
        name: '行情',
        sort: 2
      },
      {
        imgUrl: 'flash',
        checkedImgUrl: 'flash',
        linkUrl: '/flash',
        key: 'flash',
        name: '交易',
        sort: 3
      },
      {
        imgUrl: 'finance',
        checkedImgUrl: 'finance-active',
        linkUrl: '/finance',
        key: 'finance',
        name: '理财',
        sort: 4
      },
      {
        imgUrl: 'wallet',
        checkedImgUrl: 'wallet-active',
        linkUrl: '/wallet',
        key: 'wallet',
        name: '我的',
        sort: 5
      }
    ],
    CMBIT: [
      {
        imgUrl: 'home',
        checkedImgUrl: 'home-active',
        linkUrl: '/',
        key: 'home',
        name: '首页',
        sort: 1
      },
      {
        imgUrl: 'store',
        checkedImgUrl: 'store-active',
        linkUrl: '/store',
        key: 'store',
        name: '行情',
        sort: 2
      },
      {
        imgUrl: 'flash',
        checkedImgUrl: 'flash',
        linkUrl: '/flash',
        key: 'flash',
        name: '交易',
        sort: 3
      },
      {
        imgUrl: 'finance',
        checkedImgUrl: 'finance-active',
        linkUrl: '/finance',
        key: 'finance',
        name: '理财',
        sort: 4
      },
      {
        imgUrl: 'wallet',
        checkedImgUrl: 'wallet-active',
        linkUrl: '/wallet',
        key: 'wallet',
        name: '我的',
        sort: 5
      }
    ],
    ARKADEX: [
      {
        imgUrl: 'home',
        checkedImgUrl: 'home-active',
        linkUrl: '/',
        key: 'home',
        name: t('home'),
        sort: 1
      },
      {
        imgUrl: 'store',
        checkedImgUrl: 'store-active',
        linkUrl: '/store',
        key: 'store',
        name: t('market'),
        sort: 2
      },
      {
        imgUrl: 'flash',
        checkedImgUrl: 'flash',
        linkUrl: '/flash',
        key: 'flash',
        name: t('trading'),
        sort: 3
      },
      {
        imgUrl: 'finance',
        checkedImgUrl: 'finance-active',
        linkUrl: '/finance',
        key: 'finance',
        name: t('finance'),
        sort: 4
      },
      {
        imgUrl: 'wallet',
        checkedImgUrl: 'wallet-active',
        linkUrl: '/wallet',
        key: 'wallet',
        name: t('my'),
        sort: 5
      }
    ]
  }

  return themeMap[window.__themeEnv] || themeMap['TKBIT']
})

const router = useRouter()
const route = useRoute()
const pathStr = ref(route.path)
watch(route, (to) => {
  pathStr.value = to.path
})
const show = ref(false)
const handleClick = (item) => {
  if (window.__themeEnv === 'EXMINING') {
    if (item.key === 'flash') {
      show.value = true
    } else {
      router.push(item.linkUrl)
    }
  } else {
    router.push(item.linkUrl)
  }
}
const handleClick2 = (path) => {
  show.value = false
  router.push(path)
}
</script>
<style lang="scss" scoped>
.flash-popup {
  padding: 15px;
  background-color: #181630;
  &-item {
    display: flex;
    align-items: center;
    padding: 10px;
    border-radius: 10px;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
